<template>
	<div class="seting">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>账户管理</span>
			<div></div>
		</div>
		<!-- 内容 -->
		<div class="top">
			<van-cell title="修改密码" is-link to="change_pswd" />
			<van-cell title="注销账户" is-link @click="show=true" />
		</div>
		<!-- 选择原因 -->
		<van-popup v-model="show" position="bottom" class="cancel">
			<div class="cancel_title">请选择原因(必选):</div>
			<van-radio-group v-model="radio" @change="radios">
				<van-cell-group>
					<van-cell title="需要解绑手机" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="需要解绑手机" />
					</van-cell>
					<van-cell title="安全/隐私顾虑" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="安全/隐私顾虑" />
					</van-cell>
					<van-cell title="购物遇到困难" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="购物遇到困难" />
					</van-cell>
					<van-cell title="这是多余的账户" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="这是多余的账户" />
					</van-cell>
					<van-cell title="其他" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="其他" />
					</van-cell>
				</van-cell-group>
			</van-radio-group>
			<div class="cancel_btn">
				<button @click="goDestroy">下一步</button>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				radio: '需要解绑手机',
				message: ''
			}
		},
		methods: {
			//选择原因
			radios(name) {
				this.message = name;
			},
			//注销账号
			goDestroy() {
				this.$router.push({
					path: '/destroy'
				})
			}
		}
	}
</script>

<style scoped>
	@import "seting.css";

	.seting .cancel {
		z-index: 999999999999999999 !important;
	}

	.seting .cancel .cancel_title {
		padding: 0.5rem 1rem;
		color: #222;
		font-size: 0.9rem;
	}

	.seting .cancel .van-cell {
		color: #666;
	}

	.seting .cancel .cancel_btn {
		display: flex;
		justify-content: center;
	}

	.seting .cancel button {
		width: 80%;
		background: #F1452F;
		border: 0;
		color: #fff;
		font-size: 0.9rem;
		border-radius: 1rem;
		height: 1.5rem;
		line-height: 1.5rem;
		margin: 1rem 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/setting/account.vue